
import {Component, Prop, Vue} from "vue-property-decorator";
@Component
export default class DialogPreview extends Vue {
  visible = true;
  iframeCss = "";
  @Prop() private pdfUrl !: string;
  @Prop() private title !: string;

  created() {
    const width = document.documentElement.clientWidth;
    const height = document.documentElement.clientHeight;
    this.iframeCss = 'width: 100%;height:'+(Math.floor(height*0.9)-72)+'px;';
  }

  close(){
    this.$emit("close");
  }
}
